import { AccountLayout } from '../../layouts';
import { AuthSelectionScreenForm } from '../../components/AuthSelectionScreenForm';

export const AuthSelectionScreenPage = () => {
  return (
    <AccountLayout
      contents={<AuthSelectionScreenForm />}
      contentColumns={5}
    />
  );
};
